import { chain } from "lodash";

export const titleize = (string) => {
  return chain(string).startCase().capitalize().value();
};
